import React from "react";
import { Modal } from "react-bootstrap";
import InputName from "../../common/Input/InputName";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
import InputText from "../../common/Input/InputText";
import Select from "react-select";

const AddUpdateSupplier = ({
  showModal,
  setModalVisible,
  handleChange,
  modalAction,
  formData,
  handleAddOrUpdateSupplier,
  setInputError,
  gstinTypes,
}) => {
  
  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="md"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create" ? "Add Supplier" : "Update Supplier"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleAddOrUpdateSupplier}>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group">
                <InputName
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  placeholder=" Enter Supplier Name"
                  label="Name"
                  setInputNameError={setInputError}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputNumber
                  name="contact"
                  value={formData?.contact}
                  onChange={handleChange}
                  label="Mobile"
                  setInputNumberError={setInputError}
                  required={true}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputEmail
                  name="email"
                  value={formData?.email}
                  onChange={handleChange}
                  label="Email"
                  setInputEmailError={setInputError}
                  required={false}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label htmlFor="address" className="col-form-label">
                  Address:
                </label>
                <CKEditor
                  name="address"
                  editor={ClassicEditor}
                  data={formData?.address || ""}
                  onChange={(e, editor) => handleChange({ editor })}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">GSTIN Type</label>
                <Select
                  name="gstinType"
                  value={
                    formData?.gstinType
                      ? {
                          value: formData?.gstinType,
                          label: formData?.gstinTypeName,
                        }
                      : null
                  }
                  placeholder="Select GSTIN Type"
                  onChange={(selectedOption) =>
                    handleChange(selectedOption, "gstinType")
                  }
                  options={gstinTypes?.map((item) => ({
                    value: item?._id,
                    label: item?.name,
                  }))}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputText
                  name="gstin"
                  value={formData?.gstin}
                  onChange={handleChange}
                  label="GSTIN"
                  placeholder={"Enter GSTIN"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group d-flex align-items-center">
                <label htmlFor="status" className="col-form-label me-3">
                  Status:
                </label>
                {["Active", "Inactive", "Deleted"].map((status) => (
                  <div className="form-check me-3" key={status}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id={status.toLowerCase()}
                      value={status}
                      checked={formData?.status === status}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={status.toLowerCase()}
                    >
                      {status}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-primary">
              {modalAction === "create" ? "Create" : "Update"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddUpdateSupplier;
